const lazyNoveltyPageComponent = () => import('@/Pages/En/Novelty.vue');

export const noveltyRoutes = [
    {
        path: '/news/:slug',
        name: 'novelty',
        component: lazyNoveltyPageComponent,
    },
];
